import { render, staticRenderFns } from "./BlockViewer.vue?vue&type=template&id=9ba0555c&scoped=true&"
import script from "./BlockViewer.vue?vue&type=script&lang=js&"
export * from "./BlockViewer.vue?vue&type=script&lang=js&"
import style0 from "./BlockViewer.vue?vue&type=style&index=0&id=9ba0555c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ba0555c",
  null
  
)

export default component.exports